import service from "@/store/services/events-service";

export const state = () => ({
  list: {},
  event: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, event) => {
    state.event = event;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((event) => {
      commit("SET_RESOURCE", event);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((event) => {
      commit("SET_RESOURCE", event);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((event) => {
      commit("SET_RESOURCE", event);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  event: (state) => state.event,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((event) => ({
      id: event.id,
      name: `${event.firstname} ${event.lastname}`,
    }));
  },
};

const events = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default events;
